import { useState } from "react";
import Mixpanel from "mixpanel-browser";
import Button from "../form-components/Button";
import UploadDocumentModal from "./modal/UploadDocumentModal";
import { RoleRightsForModule } from "../../utils/utils";

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}

const images = importAll(require.context('../../assets/images/', false, /\.(png|jpe?g|svg|GIF|webp)$/));

const CreateDocumentNew = ({ setSubCategories }) => {

  const [currentModal, setCurrentModal] = useState("");

  const toggleModal = () => {
    setCurrentModal("");
  };

  const createNewDocumentButton = (_categoryType) => {
    setSubCategories("createNewDoc");
    Mixpanel.track("Create new document Button Clicked", {
      Page: "Dashboard page",
    });
  };

  const uploadNewDocumentButton = (_categoryType) => {
    setCurrentModal("uploadDocModal");
    Mixpanel.track("Upload new document Button Clicked", {
      Page: "Dashboard page",
    });
  };

  return (
    <>
      <div className='content-right-box'>
        <div className='intro-table-search container-fluid'>
          <div className='row align-items-top py-3'>
            <div className='col-12 col-md-6 col-xl-6'>
              <div className='title-block'>
                <h3>
                  No document have been created/uploaded.
                </h3>
                <h2>Let's start by adding your first document</h2>
              </div>

            </div>
            <div className='col-12 col-md-6 col-xl-6 mt-3 mt-md-0 text-end'>
              {RoleRightsForModule("Write", "Create Documents") &&
                <Button
                  className="btn create-doc-btn m-0 btn-inline"
                  onClick={() => createNewDocumentButton()}
                >
                  <img src={images['plusbtnicn.svg']} alt='TCT' />
                  Create new document
                </Button>}
              {RoleRightsForModule("Upload", "Upload Documents") &&
                <Button
                  onClick={() => uploadNewDocumentButton()}
                  className="btn btn-primary-md ms-3"
                  data-bs-toggle="modal"
                  data-bs-target="#Add_Document"
                >
                  <img src={images['docuploadicn.svg']} alt='TCT' className="docuploadicn me-1" />
                  Upload document
                </Button>}
            </div>
          </div>
          <div className='first-projects'>
            <div className='row'>
              <div className='col-xxl-11 col-xl-12 col-lg-12'>
                <h4>Supported Documents</h4>
                <div className='row'>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card'>
                      <span className='project-doc-icon'>
                        <img src={images['pdf-icon.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>PDF <span className='doc-tag'>Supported</span></h4>
                      <p>Portable Document Format</p>
                    </div>
                  </div>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card'>
                      <span className='project-doc-icon'>
                        <img src={images['html-icon.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>HTML <span className='doc-tag'>Supported</span></h4>
                      <p>Hypertext Markup Language</p>
                    </div>
                  </div>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card'>
                      <span className='project-doc-icon'>
                        <img src={images['rss-icon.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>RSS <span className='doc-tag'>Supported</span></h4>
                      <p>Really Simple Syndication</p>
                    </div>
                  </div>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card'>
                      <span className='project-doc-icon'>
                        <img src={images['xml-icon.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>XML <span className='doc-tag'>Supported</span></h4>
                      <p>Extensible Markup Language</p>
                    </div>
                  </div>
                </div>
                <h4>Coming Soon</h4>
                <div className='row'>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card coming-soon'>
                      <span className='project-doc-icon'>
                        <img src={images['docs.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>Word Doc. <span className='doc-tag'>Coming Soon</span></h4>
                      <p>Word Documents</p>
                    </div>
                  </div>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card coming-soon'>
                      <span className='project-doc-icon'>
                        <img src={images['txt-icon.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>TXT <span className='doc-tag'>Coming Soon</span></h4>
                      <p>Text Documents</p>
                    </div>
                  </div>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card coming-soon'>
                      <span className='project-doc-icon'>
                        <img src={images['ppt.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>PPT <span className='doc-tag'>Coming Soon</span></h4>
                      <p>PowerPoint Presentations </p>
                    </div>
                  </div>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card coming-soon'>
                      <span className='project-doc-icon'>
                        <img src={images['music-icon.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>Audio <span className='doc-tag'>Coming Soon</span></h4>
                      <p>Audible sound waves</p>
                    </div>
                  </div>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card coming-soon'>
                      <span className='project-doc-icon'>
                        <img src={images['odt-icon.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>ODT <span className='doc-tag'>Coming Soon</span></h4>
                      <p>OpenDocument Text</p>
                    </div>
                  </div>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card coming-soon'>
                      <span className='project-doc-icon'>
                        <img src={images['rtf-icon.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>RTF <span className='doc-tag'>Coming Soon</span></h4>
                      <p>Rich Text Format </p>
                    </div>
                  </div>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card coming-soon'>
                      <span className='project-doc-icon'>
                        <img src={images['epub-icon.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>ePub <span className='doc-tag'>Coming Soon</span></h4>
                      <p>Electronic Publication </p>
                    </div>
                  </div>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card coming-soon'>
                      <span className='project-doc-icon'>
                        <img src={images['json-icon.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>JSON <span className='doc-tag'>Coming Soon</span></h4>
                      <p>JavaScript Object Notation </p>
                    </div>
                  </div>
                  <div className='col-xxl-3 col-xl-3 col-lg-4'>
                    <div className='doc-card coming-soon'>
                      <span className='project-doc-icon'>
                        <img src={images['csv-icon.svg']} alt='' className='pd-icon' />
                      </span>
                      <h4>CSV <span className='doc-tag'>Coming Soon</span></h4>
                      <p>Comma-separated values </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      {currentModal === "uploadDocModal" && (
        <UploadDocumentModal
          isOpen={currentModal === "uploadDocModal"}
          toggle={toggleModal}
          setSubCategories={setSubCategories}
        />
      )}
    </>
  );
};

export default CreateDocumentNew;